<h1>Donor Search</h1>
<p-toast></p-toast>
<div class="grid mb-5">
  <div class="col-12 sm:col-6 align-items-center">
    <p-inputGroup>
      <rc-input id="searchQuickfind"
                type="text"
                [classes]="['input-quickfind']"
                placeholder="Quick Search..."
                [control]="filterValue" (input)="filterChanged()" 
                data-cy="input-quickfind"/>
      <button type="button" pButton icon="pi pi-search" class="btn-quickfind" (click)=" searchClicked =true; onPageSearch()" data-cy="btn-quickfind"></button>
    </p-inputGroup>
  </div>
  <div class="col-12 sm:col-6 align-items-center sm:text-right">
    <rc-generic-button  label="Add New Donor"
                        id="button-add-donor"
                        level="secondary"
                        size="large"
                        (click)="onAddDonor()"
                        data-cy="btn-add-donor"/>
  </div>
</div>

<p-card>
  <div id="search-column-toggle" class="flex vertical">
    <button class="btn-toggle-expand {{ isExpanded ? 'icon-minimize' : 'icon-expand' }}" (click)="toggleSelectedLabels()">
    </button>
    <p-multiSelect [group]="true"
                   [options]="groupedOptions"
                   [(ngModel)]="selectedColumns"
                   class="multi-select-columns expand-icon"
                   scrollHeight="300px"
                   optionLabel="displayColumn"
                   optionGroupLabel="label"
                   optionGroupChildren="items"
                   display="chip"
                   [maxSelectedLabels]="maxSelectedLabels"
                   [selectedItemsLabel]="'{0} items selected'"
                   placeholder="Choose Columns"
                   id="multi-select-columns"
                   data-cy="multi-select-columns"
                   [ngClass]="{'expanded': isExpanded, 'collapsed': !isExpanded}">
    </p-multiSelect>
  </div>

  <div class="search-actions grid py-2">
    <div class="col text-left">

      <p-button label="Compare"
                id="button-compare"
                (onClick)="onCompareDonors()"
                severity="secondary"
                iconImg="compare"
                [disabled]="!compareEnabled"
                styleClass="mr-1 my-1"
                data-cy="btn-compare"></p-button>

      <p-button label="Export"
                icon="fa-sharp fa-light fa-download"
                (onClick)="onExportToExcel()"
                id="button-export"
                severity="secondary"
                [outlined]="true"
                styleClass="my-1"
                [disabled]="hasNoResults()"
                class="ml-0"
                data-cy="btn-export"></p-button>

    </div>
    <div class="top-paginator" *ngIf="!hasNoResults()">

      <div class="mb-3">
        <p-button type="button"
                  icon="pi pi-chevron-left"
                  styleClass="p-button-text mr-1 grey-text-button"
                  (onClick)="pageBack()"
                  data-cy="btn-back"/>

        <p-button type="button"
                  icon="pi pi-chevron-right"
                  styleClass="p-button-text ml-1 grey-text-button"
                  (onClick)="pageForward()"
                  data-cy="btn-forward"/>
      </div>

    </div>
    <div class="col text-right">

      <rc-generic-button label="Clear All"
                         id="button-clear-filters"
                         iconImg="clear-filter"
                         borderStyle="outline"
                         (click)="resetFilters()"
                         [classes]="['my-1']" 
                         [disabled]="!isFilterActive"
                         data-cy="btn-clear"/>
                         
      <rc-generic-button label="Search"
                         id="button-search"
                         iconImg="search"
                         (click)=" searchClicked =true; onSearch()"
                         [classes]="['my-1 ml-1']"
                         data-cy="btn-search"/>
    </div>
    <p-menu #menu2 [popup]="true" [model]="selectedOptions"></p-menu>
    <!-- <div id="scrolling-search-filters" *ngIf="showScrollFilters">
    </div> -->
  </div>

  <div style="width: 100%; min-height: 22rem;">
    <p-table 
      #resultTable
      [value]="tableData"
      [columns]="selectedColumns"
      [(selection)]="selectedRows"
      selectionMode="multiple"
      dataKey="DonorID"
      [paginator]="!hasNoResults()"
      [scrollable]="true"
      scrollHeight="flex"
      [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50, 100]"
      [responsiveLayout]="'scroll'"
      [reorderableColumns]="true"
      (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="onRowUnselect($event)"
      styleClass="rc-datatable-outlined first-col-border last-col-border reorderable-columns"
      (onFilter)="onTableFilter($event)"
      data-cy="table-data">

      <ng-template pTemplate="header" let-columns id="header-filters">
        <tr>
          <th pFrozenColumn>
          </th>
          <th *ngFor="let col of columns" pReorderableColumn style="vertical-align: top;" nowrap
              pSortableColumn={{col.columnName}} id="column-{{col.columnName}}">
            <div class="sortable-title">
              <div class="column-title">{{col.displayColumn}}</div>
              <p-sortIcon field={{col.columnName}} style="cursor: pointer;" id="sort-icon-{{col.columnName}}" />
            </div>
          </th>
          <th alignFrozen="right" pFrozenColumn>
          </th>
        </tr>
        <tr class="filter">
          <th pFrozenColumn>
            <!-- <p-tableCheckbox id="checkbox-select-all"></p-tableCheckbox>-->
          </th>
          <th *ngFor="let col of columns">
            <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'StatesMultiSelect'"
                 [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
              <p-multiSelect [options]="lkpstates"
                             optionLabel="value"
                             optionValue="value"
                             [(ngModel)]="selectedStates"
                             placeholder="All"
                             [maxSelectedLabels]="1"
                             appendTo="body"
                             [displaySelectedLabel]="true"
                             emptyMessage="No states found"
                             [selectedItemsLabel]="'{0} items selected'"
                             (onChange)="filterChanged()">

              </p-multiSelect>
            </div>
            <div *ngIf="col.displayColumnType && (col.displayColumnType.columnType === 'TextFilter')
            || (col.displayColumnType.columnType === 'IDFilter')  || (col.displayColumnType.columnType === 'CommonFilter')"
                 [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
              <input pInputText type="text"
              [(ngModel)]="textFilters[col.columnName]"
              class="form-control"
              placeholder=""
              id="filter-{{col.columnName}}" (ngModelChange)="filterChanged()"/>
              </div>
          <!-- Range Filters (Date/Amount) -->
          <div *ngIf="col.displayColumnType && (col.displayColumnType.columnType === 'AmountFilter') ||
                        (col.displayColumnType.columnType === 'DateFilter')" [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
            <div class="flex relative">
                <!--Openly visible filter header area--> 
              <input *ngIf="col.filterModel.op !== 'between'"
                      type={{col.filterModel.dataType}}
                      class="p-inputtext range-state-input"
                      [value]="col.filterModel.from"
                      (change)="updateFilter(col, 'from', $event.target)"
                      (focus)="hideAllOpenOpMenus()"
                      (onModelChange)="filterChanged()" />

              <rc-generic-button label="Filter Options"
                                  iconImg="filter"
                                  [isIconOnly]="true"
                                  [classes]="['p-column-filter-menu-button']"
                                  *ngIf="col.filterModel?.ops?.length >= 2"
                                  (click)="toggleMenu(col)" />

              <div class="op-popup-menu {{col.filterModel.op==='between'?'range-selected':''}}" *ngIf="col.filterModel.isMenuOpen" (mouseleave)="col.filterModel.isMenuOpen = false">
                <ul *ngIf="col.filterModel.op!='between'">
                  @for (item of col.filterModel.ops; track item.value) {
                  @if (item.value === col.filterModel.op) {
                  <li (click)="popupMenuClickHandler(col,item)" class="selected">{{ item.label }}</li>
                  } @else {
                  <li (click)="popupMenuClickHandler(col,item)">{{ item.label }}</li>
                  }
                  }
                </ul>
                <div *ngIf="col.filterModel.op==='between'">
                  <div class="button-bar">
                    <i class="pi pi-times float" (click)="toggleMenu(col)"></i>
                  </div>

                  <div class="col">
                    <select (change)="updateFilter(col, 'op', $event.target)">
                      @for (option of col.filterModel.ops; track option.value) {
                      @if (option.value === col.filterModel.op) {
                      <option value={{option.value}} selected>{{ option.label }}</option>
                      } @else {
                      <option value={{option.value}}>{{ option.label }}</option>
                      }
                      }
                    </select>
                    <input (change)="updateFilter(col, 'from', $event.target)"
                            [value]="col.filterModel.from"
                            type={{col.filterModel.dataType}}
                            class="p-inputtext"
                            placeholder="from" />
                    <input (change)="updateFilter(col, 'to', $event.target)"
                            [value]="col.filterModel.to || ''"
                            type={{col.filterModel.dataType}}
                            class="p-inputtext"
                            *ngIf="col.filterModel.op === 'between'"
                            placeholder="to" />
                  </div>
                </div>
              </div>

              <div class="flex justify-content-end gap-1" *ngIf="col.filterModel.op === 'between'">
                Range Selected
              </div>
            </div>
          </div>
          </th>
          <th alignFrozen="right" pFrozenColumn>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowdata let-columns="columns" let-index="rowIndex">
        <tr>
          <td pFrozenColumn>
            <p-tableCheckbox [value]="rowdata"></p-tableCheckbox>
          </td>
          <td class="text-center" *ngFor="let col of columns" nowrap>
            <!-- Amount with currency pipe -->
            <span *ngIf="col.columnName !== 'Status' && col.columnName.toLowerCase().includes('amount')">
              {{ rowdata[col.columnName] | currency:'USD':'symbol' }}
            </span>
            <span *ngIf="col.columnName === 'DonorID'">
                <a [routerLink]="['/vortex/donors/card', rowdata[col.columnName]]" *ngIf="!showInDialog; else hideBlock">
                  {{ rowdata[col.columnName] }}
                </a>
                <ng-template #hideBlock>
                  <a href="javascript:void(0)" (click)="openAddDonorDialog(rowdata[col.columnName])">
                    {{ rowdata[col.columnName] }}
                  </a>
                </ng-template>
          </span>
            <!-- Date with date pipe -->
            <span *ngIf="col.columnName !== 'Status' && col.columnName.toLowerCase().includes('date')">
              {{ rowdata[col.columnName] | date: 'MM/dd/yyyy' }}
            </span>
            <!-- Default fallback for all other text columns -->
            <span *ngIf="col.columnName !== 'Status'
                         && !col.columnName.toLowerCase().includes('amount')
                         && !col.columnName.toLowerCase().includes('date')
                         && col.columnName !== 'BatchName'
                         && col.columnName !== 'DonorID'">
              {{ rowdata[col.columnName] }}
            </span>

          </td>
          <td alignFrozen="right" pFrozenColumn style="white-space: nowrap; padding: 1rem 0.5rem;">
          
            <rc-generic-button  label="View Donation History"
                                iconImg="search-money"
                                iconColor="redwood-light"
                                (click)="showDonorGivingHistory(rowdata)"
                                [isIconOnly]="true"
                                [classes]="['mx-1']"
                                data-cy="btn-donation-history"/>

            <rc-generic-button  label="Edit"
                                iconImg="cog"
                                iconColor="teal-light"
                                [isIconOnly]="true" 
                                [classes]="['mx-1']"  
                                (click)= "openEditDonorDialog(rowdata)"
                                data-cy="btn-edit"/>
          </td>

        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr *ngIf="!showLoading">
          <td [attr.colspan]="selectedColumns.length + 2" class="text-center no-data-message">
            {{NoDataMessage}}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div ngClass="medium loader-wrapper" *ngIf="showLoading">
      <rc-loading-spinner></rc-loading-spinner>
    </div>
  </div>
</p-card>
 <div class="imported-dialog-footer" *ngIf="showInDialog">

  <rc-generic-button label="Cancel" borderStyle="text-only" (click)="onCancel()" data-cy="btn-cancel"> </rc-generic-button>

  <button pButton 
          label="Select Donor"
          [disabled]="!isSingleDonorSelected()"
          class="ml-1"
          (click)="onSelectDonor()"
          data-cy="btn-select-donor"></button>
</div> 

<!-- <p-toast></p-toast> -->

<!-- Global Quick Search MODAL -->
<p-dialog [(visible)]="showDialog"
          [modal]="true"
          [maximizable]="true"
          header="Donor Card"
          styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">
  
  <app-donor-card [fromSearchDonorID]="selectedDonorId" 
                  [isDockable]="false" 
                  [isModalPopup]="true">
  </app-donor-card>

  <ng-template pTemplate="footer">
      <rc-generic-button label="Close" (click)="showDialog = false" data-cy="btn-close"> </rc-generic-button>
  </ng-template>
</p-dialog>

<!-- Add New Donor MODAL -->
<p-dialog [(visible)]="showAddNewDonorDialog"
          [modal]="true"
          [maximizable]="true"
          header="Add New Donor"
          styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

  <app-donor-add *ngIf="showAddNewDonorDialog"
                  [isModalPopup]="true"
                  (onHide)="hideAddDonorDialog()"
                  (cancel)= "hideAddDonorDialog()"
                  (donorSaved)="handleDonorSaved()">
  </app-donor-add>

</p-dialog>


<!-- Donor Giving History MODAL -->
<p-dialog [(visible)]="showDonorGivingHistoryDialog"
          [modal]="true"
          [maximizable]="true"
          header="Donor Giving History"
          styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

  <app-donor-fund-totals-grid *ngIf="showDonorGivingHistoryDialog"
                              [donorId]="selectedDonorGivingHistoryDonorId"
                              [displayOneModalPopup]="true" 
                              (onHide)="hideDonorGivingHistoryDialog()">
  </app-donor-fund-totals-grid>

</p-dialog>

<!-- Donor Dedupe -->
<p-dialog [(visible)]="showDonorDedupeDialog"
          [modal]="true"
          [maximizable]="true"
          header="Compare and Dedupe Donors"
          styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

  <app-donor-dedupe *ngIf="showDonorDedupeDialog"
                    [selectedDonors]="dedupeDonors">
  </app-donor-dedupe>

</p-dialog>
